import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseKariireSetting, ResponseKariireSettingItem } from '@/repositories/fuzoku-meisai/kaikei-kijun/data'

type PostParamItem = {
  itemName: string;
  interestRate: number;
  repaymentDeadline: string;
  settings: Kamoku[];
}

export interface KariirekinRepository {
  list (): Promise<ResponseKariireSetting>;

  save (param: ResponseKariireSettingItem[]): Promise<void>;
}

export class KariirekinRepositoryImpl implements KariirekinRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/kariirekin`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseKariireSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseKariireSettingItem[]): Promise<void> {
    const postParams: PostParamItem[] = param.map(p => ({
      itemName: p.itemName,
      interestRate: p.interestRate,
      repaymentDeadline: p.repaymentDeadline,
      settings: p.settings.targets
    }))
    await this.http.post(this.baseUrl, postParams)
  }
}
